import { GetUserViewModel } from '@/types/pam-api'

import { LocationType } from '../type'

export const showProductListExperiment = (locationType: LocationType, user: GetUserViewModel | null): boolean => {
    if (!user) return false
    const locationTypes = user.personalizations?.locationTypes

    if (!locationTypes || locationTypes.length === 0) {
        return false
    }

    return locationTypes.some((personalizationLocation) => personalizationLocation === locationType)
}
